// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rwheel {
  font-family: "Almendra", serif;
  padding-left: 1rem;
  padding-right: 1rem;
  display: grid;
  justify-items: center;
}

.rwheel__card {
  position: relative;
  background: #fff;
  border: 2px solid #d4af37;
  border-radius: 16px;
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.08);
  padding: 0.75rem;
  --wheel-size: 320px; /* default (overridden inline) */
  --spin-dur: 9s; /* default (overridden inline) */
}

/* Fixed-size wrapper prevents vertical re-centering */
.rwheel__wrap {
  position: relative;
  width: var(--wheel-size);
  height: var(--wheel-size);
  margin: 0 auto;
  line-height: 0; /* avoid baseline gaps around inline SVG */
}

/* SVG purely visual */
.rwheel__svg {
  display: block;
  width: 100%;
  height: 100%;
  pointer-events: none;
  transition: transform var(--spin-dur) cubic-bezier(0.18, 0.9, 0.08, 1);
}

/* Pointer anchored to the wrap, not the card */
.rwheel__pointer {
  position: absolute;
  z-index: 3;
  top: -6px; /* tweak if you want closer/farther from ring */
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 12px solid transparent;
  border-right: 12px solid transparent;
  border-bottom: 18px solid #d4af37;
}

/* Wheel visuals */
.rwheel__ring {
  stroke: #d4af37;
  stroke-width: 2px;
}

.rwheel__wedge {
  fill: #fff;
  stroke: rgba(212, 175, 55, 0.5);
  stroke-width: 1px;
}

.rwheel__wedge.is-rsvp {
  fill: #fff;
  stroke: #d4af37;
  stroke-width: 2px;
}

.rwheel__label {
  font-size: 12px;
  letter-spacing: 0.2px;
  fill: #0b0b0c;
  pointer-events: none;
}

.rwheel__label.is-rsvp {
  fill: #d4af37;
  font-weight: 700;
}

.rwheel__cap {
  fill: #fff;
  stroke: #d4af37;
  stroke-width: 2px;
}

/* Always-visible SPIN text centered on the wrap (won't move when CTA appears) */
.rwheel__spinText {
  position: absolute;
  z-index: 4;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: #0b0b0c;
  font-size: 0.95rem;
  letter-spacing: 0.15px;
  -webkit-user-select: none;
          user-select: none;
  pointer-events: none;
}

/* Invisible hit area over the wrap */
.rwheel__hit {
  position: absolute;
  z-index: 2;
  inset: 0;
  background: transparent;
  border: 0;
  cursor: pointer;
  outline: none;
}
.rwheel__hit:disabled {
  cursor: default;
}
.rwheel__hit:focus-visible {
  box-shadow: 0 0 0 3px rgba(146, 111, 52, 0.35) inset;
}

/* CTA lives BELOW the fixed-size wrap */
.rwheel__cta {
  margin-top: 0.65rem;
  display: grid;
  justify-items: center;
}

.rwheel__cta .ui-btn {
  height: 2.6rem;
  padding: 0 1rem;
  font-size: 0.95rem;
}

/* small labels on phones */
@media (max-width: 480px) {
  .rwheel__label {
    font-size: 11px;
  }
}`, "",{"version":3,"sources":["webpack://./src/RsvpSpinComponent/RsvpSpinComponent.scss"],"names":[],"mappings":"AAOA;EAAU,8BAAA;EAAgC,kBAAA;EAAmB,mBAAA;EAAoB,aAAA;EAAc,qBAAA;AAD/F;;AAGA;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,2CAAA;EACA,gBAAA;EACA,mBAAA,EAAA,gCAAA;EACA,cAAA,EAAA,gCAAA;AAAF;;AAGA,sDAAA;AACA;EACE,kBAAA;EACA,wBAAA;EACA,yBAAA;EACA,cAAA;EACA,cAAA,EAAA,0CAAA;AAAF;;AAGA,sBAAA;AACA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,sEAAA;AAAF;;AAGA,+CAAA;AACA;EACE,kBAAA;EACA,UAAA;EACA,SAAA,EAAA,+CAAA;EACA,SAAA;EACA,2BAAA;EACA,QAAA;EAAU,SAAA;EACV,mCAAA;EACA,oCAAA;EACA,iCAAA;AACF;;AAEA,kBAAA;AACA;EAAkB,eA/CR;EA+CyB,iBAAA;AAGnC;;AAFA;EAAkB,UAAA;EAAW,+BAAA;EAA0B,iBAAA;AAQvD;;AAPA;EAAyB,UAAA;EAAW,eAjD1B;EAiD0C,iBAAA;AAapD;;AAZA;EAAkB,eAAA;EAAgB,qBAAA;EAAqB,aApD7C;EAoDyD,oBAAA;AAmBnE;;AAlBA;EAAyB,aAnDf;EAmD6B,gBAAA;AAuBvC;;AAtBA;EAAkB,UAAA;EAAW,eApDnB;EAoDmC,iBAAA;AA4B7C;;AA1BA,gFAAA;AACA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EAAW,QAAA;EACX,gCAAA;EACA,kBAAA;EACA,cA/DQ;EAgER,kBAAA;EACA,sBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,oBAAA;AA8BF;;AA3BA,qCAAA;AACA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;AA8BF;AA5BE;EAAa,eAAA;AA+Bf;AA9BE;EAAkB,oDAAA;AAiCpB;;AA9BA,wCAAA;AACA;EAAe,mBAAA;EAAoB,aAAA;EAAe,qBAAA;AAoClD;;AAnCA;EAAuB,cAAA;EAAgB,eAAA;EAAiB,kBAAA;AAyCxD;;AAvCA,2BAAA;AACA;EAA4B;IAAiB,eAAA;EA4C3C;AACF","sourcesContent":["@use \"../styles/tokens\" as *;\r\n\r\n$primary: if(global-variable-exists(color-primary), $color-primary, #7c3aed);\r\n$text:    if(global-variable-exists(color-text),   $color-text,   #0b0b0c);\r\n$muted:   if(global-variable-exists(color-muted),  $color-muted,  #6b7280);\r\n$gold-1:  #d4af37;\r\n\r\n.rwheel { font-family: 'Almendra', serif; padding-left:1rem; padding-right:1rem; display:grid; justify-items:center; }\r\n\r\n.rwheel__card {\r\n  position: relative;\r\n  background: #fff;\r\n  border: 2px solid $gold-1;\r\n  border-radius: 16px;\r\n  box-shadow: 0 10px 26px rgba(0,0,0,.08);\r\n  padding: .75rem;\r\n  --wheel-size: 320px;   /* default (overridden inline) */\r\n  --spin-dur: 9s;        /* default (overridden inline) */\r\n}\r\n\r\n/* Fixed-size wrapper prevents vertical re-centering */\r\n.rwheel__wrap {\r\n  position: relative;\r\n  width: var(--wheel-size);\r\n  height: var(--wheel-size);\r\n  margin: 0 auto;\r\n  line-height: 0; /* avoid baseline gaps around inline SVG */\r\n}\r\n\r\n/* SVG purely visual */\r\n.rwheel__svg {\r\n  display: block;\r\n  width: 100%;\r\n  height: 100%;\r\n  pointer-events: none;\r\n  transition: transform var(--spin-dur) cubic-bezier(.18,.9,.08,1);\r\n}\r\n\r\n/* Pointer anchored to the wrap, not the card */\r\n.rwheel__pointer {\r\n  position: absolute;\r\n  z-index: 3;\r\n  top: -6px;                   /* tweak if you want closer/farther from ring */\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  width: 0; height: 0;\r\n  border-left: 12px solid transparent;\r\n  border-right: 12px solid transparent;\r\n  border-bottom: 18px solid $gold-1;\r\n}\r\n\r\n/* Wheel visuals */\r\n.rwheel__ring   { stroke: $gold-1; stroke-width: 2px; }\r\n.rwheel__wedge  { fill:#fff; stroke: rgba($gold-1,.5); stroke-width:1px; }\r\n.rwheel__wedge.is-rsvp { fill:#fff; stroke:$gold-1; stroke-width:2px; }\r\n.rwheel__label  { font-size:12px; letter-spacing:.2px; fill:$text; pointer-events:none; }\r\n.rwheel__label.is-rsvp { fill:$gold-1; font-weight:700; }\r\n.rwheel__cap    { fill:#fff; stroke:$gold-1; stroke-width:2px; }\r\n\r\n/* Always-visible SPIN text centered on the wrap (won't move when CTA appears) */\r\n.rwheel__spinText {\r\n  position: absolute;\r\n  z-index: 4;\r\n  left: 50%; top: 50%;\r\n  transform: translate(-50%, -50%);\r\n  text-align: center;\r\n  color: $text;\r\n  font-size: .95rem;\r\n  letter-spacing: .15px;\r\n  user-select: none;\r\n  pointer-events: none;\r\n}\r\n\r\n/* Invisible hit area over the wrap */\r\n.rwheel__hit {\r\n  position: absolute;\r\n  z-index: 2;\r\n  inset: 0;\r\n  background: transparent;\r\n  border: 0;\r\n  cursor: pointer;\r\n  outline: none;\r\n\r\n  &:disabled { cursor: default; }\r\n  &:focus-visible { box-shadow: 0 0 0 3px rgba($primary,.35) inset; }\r\n}\r\n\r\n/* CTA lives BELOW the fixed-size wrap */\r\n.rwheel__cta { margin-top: .65rem; display: grid; justify-items: center; }\r\n.rwheel__cta .ui-btn { height: 2.6rem; padding: 0 1rem; font-size: .95rem; }\r\n\r\n/* small labels on phones */\r\n@media (max-width: 480px) { .rwheel__label { font-size: 11px; } }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
